export const INSERT_HOLIDAY_MUTATION = `
  mutation InsertHoliday($input: HolidayInsertInput!) {
    insertHoliday(input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;

export const UPDATE_HOLIDAY_MUTATION = `
  mutation UpdateHoliday($filter: String!, $input: HolidayUpdateInput!) {
    updateHoliday(filter: $filter, input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;

export const DELETE_HOLIDAY_MUTATION = `
  mutation DeleteHoliday($filter: String!, $input: HolidayDeleteInput!) {
    deleteHoliday(filter: $filter, input: $input) {
      acknowledged
      totalImpactedData
    }
  }
`;
